module.exports = __webpack_public_path__ + "img/custom_img1.55e82332.png";